<template>
  <div class="no-view">
    <div class="no-view-btn">
      <img :src="NoViewImg" class="no-view-img" :alt="alt" />
      <div class="no-view-text">{{ title }}</div>
      <jw-button type="primary" size="large" class="no-view-btn" @click="addFirstView">{{ props.type === 0 ? '新建视图' : '重新打开' }}</jw-button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import NoViewImg from '@/assets/images/no-view-150.svg';
const emits = defineEmits(['cb']);
const props = defineProps({
  // 0 无视图  1 外部链接
  type: {
    type: Number || String,
    default: 0
  }
});
const alt = computed(() => {
  return props.type === 0 ? '暂无可用视图' : '已在外部浏览器中打开视图链接页面, 请前往外部浏览器中查看';
});
const title = computed(() => {
  return props.type === 0 ? '抱歉，暂无可用视图' : '已在外部浏览器中打开视图链接页面, 请前往外部浏览器中查看';
});

const addFirstView = () => {
  emits('cb');
};
</script>
<style scoped lang="less">
@import './xl-no-view.less';
</style>
